import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import {fetchGroupPoolConfigs, fetchGroupPoolConfigsAll} from 'store/thunks/adminGroupPoolConfigsThunk';
import {IGroupPoolConfig, IPoolConfig} from 'types';
import { ESliceDataFetchingStatus } from 'types/common';

export interface IAdminGroupPoolConfigsState {
  groupPoolConfigs: IGroupPoolConfig[];
  groupPoolConfigsAll: IGroupPoolConfig[];
  status: ESliceDataFetchingStatus;
  errorMessage: string | null;
  pagesQuantity: number;
  itemsPerPage: number;
  currentPage: number;
}

const initialState: IAdminGroupPoolConfigsState = {
  groupPoolConfigs: [],
  groupPoolConfigsAll: [],
  status: ESliceDataFetchingStatus.initial,
  pagesQuantity: 1,
  itemsPerPage: 10,
  currentPage: 0,
  errorMessage: null,
};

export const adminGroupPoolConfigsSlice = createSlice({
  name: 'adminGroupPoolConfigs',
  initialState,
  reducers: {
    groupPoolConfigsListSetPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setItemsPerGroupPoolConfigsListPage: (state, action: PayloadAction<number>) => {
      state.itemsPerPage = action.payload;
      state.currentPage = initialState.currentPage;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(fetchGroupPoolConfigs.fulfilled, (state, { payload }) => {
        state.status = ESliceDataFetchingStatus.success;
        state.groupPoolConfigs = payload.content;
        state.pagesQuantity = payload.details.totalPages;
      })
      .addCase(fetchGroupPoolConfigsAll.fulfilled, (state, { payload }) => {
        state.groupPoolConfigsAll = payload.content;
      })
      .addCase(fetchGroupPoolConfigs.pending, (state) => {
        state.status = ESliceDataFetchingStatus.loading;
        state.errorMessage = null;
      })
      .addCase(fetchGroupPoolConfigs.rejected, (state, action) => {
        state.status = ESliceDataFetchingStatus.error;
        state.errorMessage = action.error.message || 'unknown fetch group pool configs list error';
      }),
});

export const selectAdminGroupPoolConfigs = (state: RootState) => state.adminGroupPoolConfigs;

export const { groupPoolConfigsListSetPage, setItemsPerGroupPoolConfigsListPage } =
  adminGroupPoolConfigsSlice.actions;

export const adminGroupPoolConfigsReducer = adminGroupPoolConfigsSlice.reducer;
